import {useTranslation} from '@aboutyou/i18n';
import {
  FilterDropdownSelect,
  FilterFlyoutIconName,
  SortingOption,
} from '@aboutyou/ui-components';
import React from 'react';
import {useSorting} from '../../../ProductStream/utils';

interface FilterSectionSortingProps {
  sortingOptions: SortingOption[];
  defaultSortingOptionId: string;
  onOpen?: () => void;
  onClose?: () => void;
  onSort?: () => void;
}

export const FilterSectionSorting: React.FC<
  FilterSectionSortingProps
> = props => {
  const {sortingOptions, defaultSortingOptionId, onOpen, onClose, onSort} =
    props;
  const {t} = useTranslation();
  const {sorting = defaultSortingOptionId, setSorting} = useSorting();

  const onSelect = (optionId: string) => {
    onSort?.();
    setSorting(optionId, {
      shouldScrollToTop: true,
    });
  };

  return (
    <FilterDropdownSelect
      dataTestId="sortingOptionsDropdown"
      label={t('Sort')}
      displayIcon={FilterFlyoutIconName.Sort}
      activeOptionId={sorting}
      defaultOptionId={defaultSortingOptionId}
      onSelect={onSelect}
      options={sortingOptions}
      onClose={onClose}
      onOpen={onOpen}
      renderInPortal={false}
    />
  );
};
